/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const PanelRightClose = [
  "svg",
  defaultAttributes,
  [
    ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }],
    ["line", { x1: "15", x2: "15", y1: "3", y2: "21" }],
    ["path", { d: "m8 9 3 3-3 3" }]
  ]
];

export { PanelRightClose as default };
//# sourceMappingURL=panel-right-close.js.map
